/**
 * Created to serve for initial loading of symbols only - watchlist (popular, favorites), discover (top movers, new stocks), my account (my stocks)
 */

import { produce } from 'immer';
import { Entity, entity } from 'simpler-state';

const INITIAL_STATE = {
  tradeSubscription: false,
  instrumentSnapshot: false,
  chart_1D5m: false,
  chart_3M1D: false,
  isConfirmed: false,
};
export type InitialSymbolsDataLoadingStatusType = typeof INITIAL_STATE;
export type InitialSymbolsDataLoadingStatusKey = keyof InitialSymbolsDataLoadingStatusType;

let InitialSymbolsDataLoadingStatusCache: Entity<InitialSymbolsDataLoadingStatusType | null> = (
  entity(INITIAL_STATE) as any
);

const self = InitialSymbolsDataLoadingStatusCache;

function checkIfDone() {
  const { tradeSubscription, instrumentSnapshot, chart_1D5m, chart_3M1D } = (
    self?.get() as InitialSymbolsDataLoadingStatusType
  );
  return tradeSubscription && instrumentSnapshot && chart_1D5m && chart_3M1D;
}

function get() {
  return self.get() as InitialSymbolsDataLoadingStatusType;
}

function updateStatus(key: InitialSymbolsDataLoadingStatusKey, value: boolean) {
  self?.set(produce(state => {
    state[key] = value;
  }));

  const { isConfirmed } = self.get() as InitialSymbolsDataLoadingStatusType;


  if (checkIfDone()) {
    if (!isConfirmed) {
      self?.set(produce(state => {
        state.isConfirmed = true;
      }));
    }
    // Lazy require to avoid a module-init circular dependency
    // (subscription services -> this cache -> store/index -> epics -> subscription services).
    const store = require('../store/index').default;
    const { confirmInitialPriceDataLoaded } = require('../store/market-data/index');
    store?.dispatch?.(confirmInitialPriceDataLoaded());
  }
}

export default {
  get,
  use: self.use,
  updateStatus,
  checkIfDone,
};
